import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { cloneDeep } from 'lodash';

import categoriesQuery from './CategoriesContext.graphql';

const CategoriesContext = React.createContext([]);

export const CategoriesProvider = ({ children }) => {
  const { data, error, loading } = useQuery(categoriesQuery);
  const clone = cloneDeep(data);

  const value = {
    isLoading: loading,
    isError: error,
    categories: clone?.fetchAppCategories?.data || [],
  };

  return <CategoriesContext.Provider value={value}>{children}</CategoriesContext.Provider>;
};

CategoriesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default CategoriesContext;
